const feelingLuckyRequest = '/search/?drug=BGJ398,binimetinib,BKM120,BYL719&dataset=1&genes=SOX9,RAN,TNK2,EP300,PXN,NCOA2,AR,NRIP1,NCOR1,NCOR2&genomics=Mutation,CNV,RNASeq&threshold=2';

export default feelingLuckyRequest;
